import { getLogger } from '@logtape/logtape';
import axios, { AxiosResponse } from 'axios';

import { serializeApiError } from '@/utils/log-utils.ts';

const logger = getLogger(['service', 'printer']);

interface TicketResponse {
    id: number;
}

export const printPcsTicket = async (auth_token: string, endpoint: string): Promise<[boolean, number | undefined]> => {
    try {
        const response: AxiosResponse<TicketResponse | undefined> = await axios.get(
            `${import.meta.env.VITE_PROTOCOL}://${endpoint}/`,
            {
                headers: {
                    token: auth_token,
                },
            }
        );
        logger.debug('PCS ticket printed', { response: response });
        return [true, response?.data?.id];
    } catch (error) {
        logger.debug('Failed to print the PCS ticket', { error: error, ...serializeApiError(error) });
        return [false, undefined];
    }
};

export const updatePcsTicket = async (
    auth_token: string,
    endpoint: string,
    stack: string,
    ticket: string | undefined = undefined
): Promise<boolean> => {
    try {
        const response: AxiosResponse<TicketResponse | undefined> = await axios.get(
            `${import.meta.env.VITE_PROTOCOL}://${endpoint}/?stack=${stack}${ticket ? `&ticket=${ticket}` : ''}`,
            {
                headers: {
                    token: auth_token,
                },
            }
        );
        logger.debug('PCS ticket updated', { response: response });
        return response.status >= 200 && response.status < 300;
    } catch (error) {
        logger.debug('Failed to update the PCS ticket', { error: error, ...serializeApiError(error) });
        return false;
    }
};

export const isPrinterLive = async (endpoint: string): Promise<boolean> => {
    try {
        const response = await axios.get(`${import.meta.env.VITE_PROTOCOL}://${endpoint}/`, {
            timeout: 1000,
        });
        logger.debug('Printer responded', { response: response });
        return true;
    } catch (error) {
        logger.debug('Printer did not respond', { error: error, ...serializeApiError(error) });
        return false;
    }
};
